export interface ICallRecordingRequest {
  userId: string,
  verifyRecording: boolean,
}

export class CallRecordingRequest implements ICallRecordingRequest {
  userId: string;
  verifyRecording: boolean;
}